import { _ as _objectSpread2 } from '../../_rollupPluginBabelHelpers-a38db067.js';
import { isTheme, defaultBreakpoints, getMedias, isFunction } from '../utils.js';
import { get } from '../core/core-utils.js';
import '../core/parser.js';
import '../core/compose.js';
import '../core/style-function.js';
import '../core/system.js';
import '../parsers/typography.js';
import '../parsers/transition.js';
import '../parsers/margin.js';
import '../parsers/padding.js';
import '../parsers/space.js';
import '../parsers/shadow.js';
import '../parsers/animation.js';
import '../parsers/background.js';
import '../parsers/border.js';
import '../parsers/color.js';
import '../parsers/flexbox.js';
import '../parsers/grid.js';
import '../parsers/layout.js';
import '../parsers/other.js';
import '../parsers/position.js';
import { parsers } from '../parsers/parsers-config.js';
import { pseudoSelectors } from '../parsers/pseudo.js';
import { getParserDicts } from './css-utils.js';

const {
  aliases,
  multiples,
  transforms
} = getParserDicts(parsers);
function responsive(styles = {}) {
  return theme => {
    const result = {};
    const breakpoints = get(theme, 'breakpoints', defaultBreakpoints);
    const mediaQueries = [...Object.entries(getMedias(breakpoints)).map(([_, value]) => value)];
    if (!styles) return result;
    Object.keys(styles).forEach(key => {
      const value = isFunction(styles[key]) ? styles[key](theme) : styles[key];
      if (value === null) {
        return;
      }
      if (!Array.isArray(value)) {
        result[key] = value;
        return;
      }
      for (let i = 0; i < value.slice(0, mediaQueries.length).length; i += 1) {
        const media = mediaQueries[i];
        if (!media) {
          result[key] = value[i];
          // eslint-disable-next-line no-continue
          continue;
        }
        result[media] = result[media] || {};
        if (value[i] == null) {
          // eslint-disable-next-line no-continue
          continue;
        }
        result[media][key] = value[i];
      }
    });
    return result;
  };
}
function css(args) {
  return props => {
    let theme = {};
    if (isTheme(props)) {
      theme = _objectSpread2(_objectSpread2({}, theme), props.theme);
    } else {
      theme = _objectSpread2(_objectSpread2({}, theme), props);
    }
    const result = {};
    const obj = typeof args === 'function' ? args(theme) : args;
    const styles = responsive(obj)(theme);
    Object.keys(styles).forEach(key => {
      const x = styles[key];
      const val = isFunction(x) ? x(theme) : x;
      if (val && typeof val === 'object') {
        if (Object.keys(pseudoSelectors).includes(key)) {
          result[pseudoSelectors[key].join(', ')] = css(val)(theme);
          return;
        }
        result[key] = css(val)(theme);
        return;
      }
      const prop = get(aliases, key, key);
      const transform = get(transforms, prop, get);
      let value;
      // when the val is a number and less than 0, resolve it from the theme
      // using its absolute value and then make the result a negative.
      // otherwise, just resolve the value.
      if (typeof val === 'number' && val < 0) {
        const abs = Math.abs(val);
        const n = transform({}, abs, abs);
        value = typeof n === 'string' ? `-${n}` : n * -1;
      } else {
        value = transform({}, val, val);
      }
      if (multiples[prop]) {
        const dirs = multiples[prop];
        for (let i = 0; i < Object.keys(dirs).length; i += 1) {
          if (Array.isArray(value)) {
            result[dirs[i]] = value[i];
          } else {
            result[dirs[i]] = value;
          }
        }
      } else {
        result[prop] = value;
      }
    });
    return result;
  };
}

export { css };
